import React, { useState } from 'react';
import { Box, Card, Chip, TextField, Autocomplete, ListItem, ListItemText, Tooltip, IconButton } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, ActionButton } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import ShowComponents from '../Common/ShowComponent';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import DeleteIcon from '@mui/icons-material/Delete';

const SarasPatientCategory = ({ Title, ...props }) => {
    const [state, setState] = useState({
        CategoryAddText: null,
        CategoryList: [],
        tempCategoryList: [],
        isDeleteClicked: false,
        SelectedCetegory: {},
        isDltClicked: false,
        slcDeleteCetegory: {}
    });

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const getApiCall = () => {
        getPatientCategoryData();
        getPatientCategoryList();
    }

    const getPatientCategoryData = () => {
        try {
            let params = ''
            if(props?.fromIp){
                params = Serviceurls.SAR_IP_DOC_NOTES_PATIENT_CATEGORY + `?clinic_id=${props?.clinicId}&ip_admission_id=${props?.admission_id}&doctor_id=${props?.doctor_id}&patient_id=${props.patientId}`
            }else{
                params = Serviceurls.SARAS_DOC_PATIENT_CATEGORY_GET + `?appointment_id=${props?.appointmentId}&patient_id=${props.patientId}`
            }
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ CategoryList: response.data.data || [] })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getPatientCategoryList = () => {
        try {
            let params = ''
            if(props?.fromIp){
                params = Serviceurls.SARAS_DOC_PATIENT_CATEGORY_SUGG_GET + `?clinic_id=${props?.clinicId}&doctor_id=${props?.doctor_id}`
            }else{
                params = Serviceurls.SARAS_DOC_PATIENT_CATEGORY_SUGG_GET
            }
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        updateState({ tempCategoryList: response.data.data })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    //chip delete functions
    const categoryPopupClose = () => {
        updateState({
            isDltClicked: false,
            slcDeleteCetegory: {},
        })
    }

    const deleteCategory = () => {
        try {
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_PATIENT_CATEGORY : Serviceurls.SARAS_DOC_PATIENT_CATEGORY_GET
            RestAPIService.delete(params + "?id=" + state.slcDeleteCetegory?.id)
                .then((response) => {
                    if (response.data.status === "success") {
                        categoryPopupClose()
                        props.successMessage(response.data.message)
                        getPatientCategoryData()
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    // template delete functions
    const popupClose = () => {
        updateState({
            isDeleteClicked: false,
            SelectedCetegory: null,
        })
    }

    const deleteTempCategory = () => {
        try {
            RestAPIService.delete(Serviceurls.SARAS_DOC_PATIENT_CATEGORY_SUGG_GET + "?id=" + state.SelectedCetegory?.id+"&doctor_id="+ props?.doctor_id)
                .then((response) => {
                    if (response.data.status === "success") {
                        popupClose()
                        props.successMessage(response.data.message)
                        getPatientCategoryList()
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const ClearData = () => {
        updateState({
            CategoryAddText: null,
            isDeleteClicked: false,
            SelectedCetegory: {},
            isDltClicked: false,
            slcDeleteCetegory: {},
        })
    }

    const postPatientCategory = () => {
        const { appointmentId, patientId } = props
        try {
            if (CommonValidation.removeSpace(state.CategoryAddText?.category || state.CategoryAddText) !== "") {
                const data = {
                    appointment_id: appointmentId,
                    patient_id: patientId,
                    category: state.CategoryAddText?.category ? state.CategoryAddText?.category : state.CategoryAddText || "",
                }
                if(props?.fromIp){
                    data['clinic_id'] = props?.clinicId || null
                    data['ip_admission_id'] = props?.admission_id || null
                    data['doctor_id'] = props?.doctor_id || null
                }
                let path = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_PATIENT_CATEGORY : Serviceurls.SARAS_DOC_PATIENT_CATEGORY_GET
                RestAPIService.create(data, path)
                    .then((response) => {
                        if (response.data.status === "success") {
                            props.successMessage(response.data.message);
                            getPatientCategoryData();
                            getPatientCategoryList();
                            ClearData()
                        } else {
                            props.errorMessage(response.data.message)
                        }
                    }).catch(error => {
                        props.errorMessage(error?.response?.data?.message || error.message)
                    })
            } else {
                props.errorMessage("Select Category")
            }
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const { t } = props;

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected)}
                    <Box display="flex" alignItems={"center"} gap={"0.625dvw"}>
                        <ActionButton
                            text={"Clear"}
                            emed_tid='doc_notes_bold_clr'
                            variant={'outlined'}
                            onClick={() => ClearData()}
                        />
                        <ActionButton
                            text={"Save"}
                            emed_tid='doc_notes_bold_save'
                            disabled={!(state?.CategoryAddText || state?.CategoryAddText?.category) || props.isLocked}
                            onClick={() => { postPatientCategory() }}
                        />
                    </Box>
                </Box>
                <Box sx={{ width: "100%", margin: "0.5vw" }}>
                    <Autocomplete
                        freeSolo
                        fullWidth
                        size="small"
                        disabled={props.isLocked}
                        options={state.tempCategoryList}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.category || ""
                        }
                        value={
                            typeof state?.CategoryAddText === "string"
                                ? state.CategoryAddText
                                : state?.CategoryAddText?.category || ""
                        }
                        onChange={(e, newValue) => { updateState({ CategoryAddText: newValue }) }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                autoComplete="off"
                                label={`Enter or Select ${Title}`}
                                size="small"
                                className="eMed_DocNotes_TextFields"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (CommonValidation.ALPHA_NUM_SPLCHAR(value) || value === "") {
                                        updateState({ CategoryAddText: value });
                                    }
                                }}
                            />
                        )}
                        renderOption={(props, item) => (
                            <li {...props} style={{ padding: "0vh 1.5vh" }}>
                                <ListItem
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: 0,
                                        margin: 0,
                                    }}
                                >
                                    <ListItemText
                                        primary={
                                            item?.category?.length > 90 ? (
                                                <Tooltip placement="top" title={item.category}>
                                                    <div>{item.category.slice(0, 90) + "..."}</div>
                                                </Tooltip>
                                            ) : (
                                                item.category
                                            )
                                        }
                                    />
                                    <IconButton
                                        disabled={props.isLocked}
                                        edge="end"
                                        color="error"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            updateState({
                                                isDeleteClicked: true,
                                                SelectedCetegory: item,
                                            });
                                        }}
                                    >
                                        <Tooltip placement="top" title="Delete" arrow>
                                            <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} />
                                        </Tooltip>
                                    </IconButton>
                                </ListItem>
                            </li>
                        )}
                    />
                </Box>

                <Box className="eMed_DocNotes_FreqChips_Wrapp">
                    {
                        state.CategoryList?.length > 0 ? state.CategoryList.map((item, index) => (
                            <Chip
                                size='small'
                                className={`eMed_chip ${'eMed_Chip_Border'}`}
                                key={index}
                                label={item?.category}
                                variant={"outlined"}
                                disabled={props.isLocked}
                                onDelete={() => { updateState({ isDltClicked: true, slcDeleteCetegory: item }) }}
                            />
                        )) : null
                    }
                </Box>
                {/* Chip delete */}
                {state.isDltClicked && <DeletePopup
                    DeletTitle={`${t("deleteMsg")}  ${t("Category")} - ${state.slcDeleteCetegory?.category || "-"} ?`}
                    deleteAlertPopupClose={categoryPopupClose.bind(this)}
                    removeData={deleteCategory.bind(this)}
                />}
                {/* Template Delete */}
                {state.isDeleteClicked && <DeletePopup
                    DeletTitle={`${t("deleteMsg")}  ${t("Category")} ${state.SelectedCetegory?.category || "-"} From Suggestion List ?`}
                    deleteAlertPopupClose={popupClose.bind(this)}
                    removeData={deleteTempCategory.bind(this)}
                />}
            </Card>
        </ShowComponents >
    )
}

export default withTranslation()(SarasPatientCategory)